import type { IEntityParamItem } from '@/types/entityParams';
import type { IToolUserParamListRowApi, IToolUserParamMutationRow } from '@/types/toolUserParams';
import { AbstractModel } from './abstractModel';

export class ToolUserParamItem extends AbstractModel implements IEntityParamItem {
    id: number = 0;
    param: string = '';
    toolUserId: number = 0;
    value: string = '';

    constructor(data?: IToolUserParamListRowApi) {
        super();

        if (data) {
            this.id = data.id;
            this.toolUserId = data.tool_user_id;
            this.param = data.param;
            this.value = data.value ?? '';
        }
    }

    toCreateApiData(): IToolUserParamMutationRow {
        return {
            tool_user_id: this.toolUserId,
            param: this.param.trim(),
            value: this.formatValue(this.value),
        };
    }

    toUpdateApiData(fields: Array<'param' | 'value'>): IToolUserParamMutationRow {
        const row: IToolUserParamMutationRow = { id: this.id };

        if (fields.includes('param')) {
            row.param = this.param.trim();
        }

        if (fields.includes('value')) {
            row.value = this.formatValue(this.value);
        }

        return row;
    }

    private formatValue(value: string): string | null {
        const trimmed = value.trim();
        return trimmed === '' ? null : trimmed;
    }
}
